import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from 'services/api';
import type { IdBookmark, PqlBookmark, BookmarkType } from './types';

export type DeleteBookmarkParams = {
  bookmark: IdBookmark | PqlBookmark;
  type: BookmarkType;
};

const useDeleteBookmark = () => {
  const api = useApi();
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ bookmark, type }: DeleteBookmarkParams) => {
      const records = client.getQueryData<(IdBookmark | PqlBookmark)[]>(['bookmarks', type]);

      await api.delete(`/bookmarks/${type}/${bookmark.id}`);

      client.setQueryData(['bookmarks', type], records?.filter((r) => r.id !== bookmark.id) ?? []);
    },
  });
};

export { useDeleteBookmark };
